import { render } from "./ConfirmAdditionalQuestions.vue?vue&type=template&id=3335184a"
import script from "./ConfirmAdditionalQuestions.vue?vue&type=script&lang=js"
export * from "./ConfirmAdditionalQuestions.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css"

import exportComponent from "C:\\Users\\carl.DC_ADVOCATIA\\Documents\\GitHub\\benefit-screening-client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__